import { createRouter, createWebHistory } from 'vue-router'
import Companion from '../components/Companion.vue'
import { Login as LoginScreen } from '@monolith/components'
import ChooseStore from '../components/Auth/ChooseStore.vue'
import ChooseStation from '../components/Auth/ChooseStation.vue'
import PasswordReset from '../components/Auth/PasswordReset.vue'

const routes = [
  {
    path: '/',
    name: 'LoginScreen',
    component: LoginScreen
  },
  {
    path: '/companion',
    name: 'companionscreen',
    component: Companion
  },
  {
    path: '/chooseStore',
    name: 'ChooseStore',
    component: ChooseStore
  },
  {
    path: '/chooseStation',
    name: 'ChooseStation',
    component: ChooseStation
  },
  {
    path: '/password',
    name: 'password',
    component: PasswordReset
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
